import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { toCroppedImage } from '~/shared/utils/image'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ArticleFilterOption extends BaseModel {
  static override constructorName = 'ArticleFilterOption'

  id: number = 0
  name: string = ''
  image: string = ''
  isActive: boolean = false

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
      this.image = toCroppedImage(this.image)
    }
  }
}

registerModel(ArticleFilterOption)
